import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import pinImage from "../../pin.png";
// import mapboxConfig from "../../mapbox_config.json";

const MapBox = ({ accesstoken, theme, configsrc }) => {
  const [map, setMap] = useState(null);
  // const [mapboxConfig, setMapboxConfig] = useState([])
  const mapContainer = useRef(null);

  useEffect(() => {
    async function initLoad() {
      try {
        const response = await axios.get(configsrc);
        const mapboxConfig = response.data;
        mapboxgl.accessToken = accesstoken;

        const initializeMap = ({ setMap, mapContainer }) => {
          const map = new mapboxgl.Map({
            container: mapContainer.current,
            style: theme, // stylesheet location
            center: [0, 0],
            zoom: 0,
          });

          const renderMarkerMarkup = (marker) => {
            let generalContent = marker.general
              ? renderGeneralContent(JSON.parse(marker.general))
              : "";
            let discoverContent = marker.discover
              ? renderDiscoverContent(JSON.parse(marker.discover))
              : "";
            let exploreContent = marker.explore
              ? renderExoloreContent(JSON.parse(marker.explore))
              : "";
            let challengeContent = marker.challenge
              ? renderChallengeContent(JSON.parse(marker.challenge))
              : "";

            return `
        <div class="popupContainer">
          <h1><div class="pin"></div>${marker.title}</h3>
          ${generalContent}
          ${discoverContent ? "<hr/>" : ""}
          ${discoverContent}
          ${exploreContent ? "<hr/>" : ""}
          ${exploreContent}
          ${challengeContent ? "<hr/>" : ""}
          ${challengeContent}
        </div>
      `;
          };

          const renderGeneralContent = (content) => {
            return `
        <div class="content">
          ${renderEmailField(content.email)}  
          ${renderWebsiteField(content.website)}
          ${renderPartnerField(content.name)}
        </div>
        `;
          };

          const renderDiscoverContent = (content) => {
            return `
        <div class="content">
        <h2 class="dot dot-purple"><i>FIRST</i> LEGO LEAGUE DISCOVER</h2>
          ${renderEmailField(content.email)}  
          ${renderWebsiteField(content.website)}
          ${renderPartnerField(content.name)}
        </div>
        `;
          };

          const renderExoloreContent = (content) => {
            return `
        <div class="content">
        <h2 class="dot dot-green"><i>FIRST</i> LEGO LEAGUE EXPLORE</h2>
          ${renderEmailField(content.email)}  
          ${renderWebsiteField(content.website)}
          ${renderPartnerField(content.name)}
        </div>
        `;
          };

          const renderChallengeContent = (content) => {
            return `
        <div class="content">
        <h2 class="dot dot-red"><i>FIRST</i> LEGO LEAGUE CHALLENGE</h2>
          ${renderEmailField(content.email)}
          ${renderWebsiteField(content.website)}
          ${renderPartnerField(content.name)}
        </div>
        `;
          };

          const renderEmailField = (email) => {
            if (!email) {
              return "";
            }

            let emailContent = "";
            email.forEach((e) => {
              emailContent += `<a href="mailto:${e}">${e}</a>`;
            });

            return `
          <div class="email-container">
            <h4>EMAIL</h4>
            ${emailContent}
          </div>
        `;
          };

          const renderWebsiteField = (website) => {
            if (!website) {
              return "";
            }
            return `
          <h4>WEBSITE</h4>
          <a target="_blank" href="${website}">${website}</a>
        `;
          };

          const renderPartnerField = (partner) => {
            if (!partner) {
              return "";
            }
            return `
          <h4>PARTNER</h4>
          <p>${partner}</p>
        `;
          };

          map.fitBounds(
            [
              [-150.962795, 80.899148],
              [183.388626, -39.671256],
            ],
            { duration: 0 }
          );

          map.on("load", () => {
            map.addControl(new mapboxgl.NavigationControl());
            map.scrollZoom.disable();
            map.loadImage(pinImage, function (error, image) {
              if (error) throw error;
              map.addImage("pin", image);
              map.addSource("places", mapboxConfig);

              map.addLayer({
                id: "places",
                type: "symbol",
                source: "places",
                layout: {
                  "icon-image": "pin",
                  "icon-allow-overlap": true,
                },
              });

              map.on("click", "places", function (e) {
                const coordinates = e.features[0].geometry.coordinates.slice();
                const description = renderMarkerMarkup(
                  e.features[0].properties
                );

                // Ensure that if the map is zoomed out such that multiple
                // copies of the feature are visible, the popup appears
                // over the copy being pointed to.
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                  coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }

                new mapboxgl.Popup()
                  .setLngLat(coordinates)
                  .setHTML(description)
                  .addTo(map);
              });

              map.on("mouseenter", "places", function () {
                map.getCanvas().style.cursor = "pointer";
              });

              // Change it back to a pointer when it leaves.
              map.on("mouseleave", "places", function () {
                map.getCanvas().style.cursor = "";
              });
            });
          });
        };

        if (!map) initializeMap({ setMap, mapContainer });
      } catch (err) {
        // surpress
        console.error("Problem loading config");
      }
    }

    initLoad();
  }, [map]);

  return (
    <div ref={(el) => (mapContainer.current = el)} className="mapContainer" />
  );
};

export default MapBox;
